export default __webpack_public_path__ + "static/media/Taq_DNA_Polymerase.c28bfc97.svg";